import React, { useContext } from "react";
import "./PageFive.scss";
import { BuildingsContext } from "../../../bContext";
import auto from "../../../assets/auto_whole.PNG"
import autoEn from "../../../assets/selfEn2.png"

function PageFive() {
  const { switchToEnglish} = useContext(
    BuildingsContext
  );
  return (
    <>
    <div className="pageFive">
      <div className="speech-bubble4">
      {switchToEnglish === false ? 
        <p className="first">
          Jeśli chcesz zobaczyć całą prezentację, za jednym kliknięciem, włącz <span>"Autoprezentację"</span>. Możesz ją wyłączyć i ponownie uruchomić klikając w dowolnym momencie ikonę "Autoprezentacja".
        </p>
        :
        <p className="first">
        If you want to see the whole presentation, turn on <span> "self-presentation" </span>. You can turn it on and restart it by clicking on the  <span> "self-presentation" </span> icon at any time.
      </p>
      }
        <div className="inner-triangle-right4"></div>
      </div>
      <div className="menu-pg4" style={{backgroundImage: !switchToEnglish ?  `url(${auto})` : `url(${autoEn})`}}></div>

      <div>
        <div className="modal-header-ins"></div>
        <div className="modalbtn"></div>
        <div className="defaultbtn"></div>
      </div>
    </div>      
    </>
  );
}

export default PageFive;
